
<cu-dynamic-page-workflow-progress class="ww-position--sticky" [page]="page" [flow]="flow"></cu-dynamic-page-workflow-progress>
<cu-dynamic-page-layout [page]="page" [flow]="flow">

  <div page-body>
    <cu-dynamic-page-header [page]="page" [flow]="flow" ></cu-dynamic-page-header>
    <cu-dynamic-page-review [page]="page" [flow]="flow"></cu-dynamic-page-review>
  </div>
</cu-dynamic-page-layout>
